import { render, staticRenderFns } from "./ScaleSelector.vue?vue&type=template&id=4c2b7603&scoped=true&"
import script from "./ScaleSelector.vue?vue&type=script&lang=js&"
export * from "./ScaleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2b7603",
  null
  
)

export default component.exports